import { SkinnableComponent } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import useOrderHistoryLogic from './OrderHistoryLogic';
import BasicOrderHistorySkin from './skins/BasicOrderHistorySkin';

/**
 * 주문 내역 스킨 가능 컴포넌트
 */
export const OrderHistorySkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.ORDER_HISTORY,
  name: '주문 내역',
  category: 'ecommerce',
  supportsExternalSkins: true,
  options: [],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicOrderHistorySkin as any
  },
  useLogic: useOrderHistoryLogic as any,
  defaultProps: {
    title: '주문 내역',
    emptyText: '주문 내역이 없습니다.',
    itemsPerPage: 10,
    showPagination: true,
    showSearch: true,
    showFilter: true,
    showOrderDetail: true,
    showCancelButton: true,
    showTrackingButton: true,
    primaryButtonColor: '#007bff',
    secondaryButtonColor: '#6c757d',
    dangerButtonColor: '#dc3545',
    statusColors: {
      pending: '#ffc107',
      processing: '#17a2b8',
      shipped: '#007bff',
      delivered: '#28a745',
      cancelled: '#dc3545',
      refunded: '#6c757d'
    }
  }
};